import * as React from 'react';
import { SiteConfigProvider } from '@sorpetaler/ui/src/context/SiteConfigContext';
import { usSiteConfig } from './site-config';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <SiteConfigProvider config={usSiteConfig}>{element}</SiteConfigProvider>
);
